<!-- eslint-disable -->
<template lang="pug">
    .playground
        .playground__item(v-for="(item, index) in items")
            img(:src="item.value | apiFile" @click="$emit('selectItem', item, index)")
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            items: Array,
        },
    }
</script>

<style scoped lang="scss">
    .playground {
        width: 100%;
        margin: 0 auto;
        display: flex;
    }

    .playground__item {
        border: 2px solid $hsl-color-gray-94;
        border-radius: $border-radius-10;
        background-color: $x-color-white;
        padding: 10px;
        cursor: pointer;
        user-select: none;
        margin-right: 10px;
        box-sizing: border-box;
    }

    .playground__item:last-child {
        margin-right: 0;
    }

    .playground__item:empty {
        visibility: hidden;
    }

    .playground__item--correct {
        pointer-events: none;
        border: 2px solid $hsl-color-green-58;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
